import cx from 'classnames';
import type { ReactNode } from 'react';

export interface MenuIconProps {
  noOfBars?: number;
  isOrange?: boolean;
  isOpen?: boolean;
  text?: ReactNode;
}

export default function MenuIcon({
  isOrange,
  noOfBars = 3,
  isOpen,
  text,
}: MenuIconProps): JSX.Element {
  return (
    <span
      className={cx('wa-icons-bars', {
        'wa-icons-bars--is-open': isOpen,
      })}
    >
      <span className="wa-icons-bars__container">
        {[...Array(noOfBars).keys()].map((key) => (
          <span
            key={key}
            className={cx('wa-icons-bars__bar', {
              'wa-icons-bars__bar--orange': isOrange,
            })}
          />
        ))}
      </span>
      {text ? <span className="wa-icons-bars__text">{text}</span> : null}
    </span>
  );
}
